import PropTypes from "prop-types"

export const SeoType = PropTypes.shape({
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.object,
  tracking: PropTypes.arrayOf(String),
  author: PropTypes.object,
  schema_template: PropTypes.string,
  schema: PropTypes.string,
})
